<template>
  <v-flex>
    <div class="mobile-fixed-filler"></div>

    <div
      v-if="order.items.data[0]"
      class="mobile-fixed-bottom"
      :style="
        $vuetify.theme.dark
          ? 'background-color: #2d2d2d'
          : 'background-color: #f5f5f5'
      "
    >
      <!-- Mobile View: Expansion Panel -->
      <v-expansion-panels v-if="isMobile" focusable flat>
        <v-expansion-panel>
          <v-expansion-panel-header
            :color="$vuetify.theme.dark ? '#2d2d2d' : '#f5f5f5'"
            expand-icon="keyboard_control_key"
          >
            <span>DETALHES DO PEDIDO</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            :color="$vuetify.theme.dark ? '#2d2d2d' : '#f5f5f5'"
            class="pt-3"
          >
            <div class="headline word-no-break">
              {{ order.items.data[0].saleable.course }}
            </div>
            <div class="word-no-break mt-3" style="color: grey">
              {{ order.items.data[0].saleable.description }}
            </div>
            <v-btn
              v-if="!couponApplyed"
              color="primary"
              class="pl-0"
              text
              @click="showCuponArea = !showCuponArea"
            >
              tem um cupom?
            </v-btn>
            <div v-if="showCuponArea" id="coupon-area">
              <div class="coupon-container">
                <v-text-field
                  v-model="code"
                  :disabled="!couponEnabled"
                  :loading="loading"
                  class="mt-0 pt-0 mb-0"
                  flat
                  clearable
                  dense
                  autofocus
                  hide-details="auto"
                  label="Cupom"
                  name="couponCode"
                  placeholder="código do cupom"
                  prepend-inner-icon="local_offer"
                  outlined
                  type="text"
                  v-mask="'XXXXXXXXXXXXXXXXXXXXX'"
                  @click:clear="clearCoupon"
                ></v-text-field>
                <v-btn
                  :disabled="!couponEnabled || couponApplyed || loading"
                  class="mt-0 pt-0"
                  color="primary"
                  elevation="0"
                  rounded
                  @click="applyCoupon"
                >
                  {{ couponApplyed ? "Aplicado" : "Aplicar" }}
                </v-btn>
              </div>
            </div>

            <order-bump
              v-if="courseRecommendation"
              :disableCheck="!couponEnabled"
              @disableCheck="!(couponEnabled = $event)"
              :courseRecommendation="courseRecommendation"
              :charge-is-triggered="chargeTriggered"
              @courseRecommendationChanged="courseRecommendation = $event"
              :order="order"
              @orderChanged="order = $event"
              @updateCart="onUpdateCart"
            ></order-bump>

            <div v-if="order.discount_amount > 0">
              <div class="valores-com-cupom">
                <span>Subtotal</span>
                <span style="white-space: pre-line">R$ {{ itemPrice }}</span>
              </div>
              <div class="valores-com-cupom">
                <span>Desconto</span>
                <span class="success--text">- R$ {{ discount }}</span>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Desktop View: Full Details -->
      <template v-else>
        <div class="headline word-no-break">
          {{ order.items.data[0].saleable.course }}
        </div>
        <div class="word-no-break mt-2" style="color: grey">
          {{ order.items.data[0].saleable.description }}
        </div>
        <v-btn
          v-if="!couponApplyed"
          color="primary"
          class="pl-0"
          text
          @click="showCuponArea = !showCuponArea"
        >
          tem um cupom?
        </v-btn>
        <div v-if="showCuponArea" id="coupon-area">
          <div class="coupon-container">
            <v-text-field
              v-model="code"
              :disabled="!couponEnabled"
              :loading="loading"
              class="mt-0 pt-0 mb-0"
              flat
              clearable
              dense
              autofocus
              hide-details="auto"
              label="Cupom"
              name="couponCode"
              placeholder="código do cupom"
              prepend-inner-icon="local_offer"
              outlined
              type="text"
              v-mask="'XXXXXXXXXXXXXXXXXXXXX'"
              @click:clear="clearCoupon"
            ></v-text-field>
            <v-btn
              :disabled="!couponEnabled || couponApplyed || loading"
              class="mt-0 pt-0"
              color="primary"
              elevation="0"
              rounded
              @click="applyCoupon"
            >
              {{ couponApplyed ? "Aplicado" : "Aplicar" }}
            </v-btn>
          </div>
        </div>
        <order-bump
          v-if="courseRecommendation"
          :disableCheck="!couponEnabled"
          @disableCheck="!(couponEnabled = $event)"
          :courseRecommendation="courseRecommendation"
          :charge-is-triggered="chargeTriggered"
          @courseRecommendationChanged="courseRecommendation = $event"
          :order="order"
          @orderChanged="order = $event"
          @updateCart="onUpdateCart"
        ></order-bump>

        <div v-if="order.discount_amount > 0">
          <div class="valores-com-cupom">
            <span>Subtotal</span>
            <span style="white-space: pre-line">R$ {{ itemPrice }}</span>
          </div>
          <div class="valores-com-cupom">
            <span>Desconto</span>
            <span class="success--text">- R$ {{ discount }}</span>
          </div>
        </div>
      </template>
      <!-- Total + Charge Button (Always Visible) -->
      <div class="total-charge">
        <div class="preco-parcelado">
          <p>Total</p>
          <div>
            <p class="installment">{{ textInstallment }}</p>
            <p class="amount">{{ orderAmount }}</p>
          </div>
        </div>
        <div class="margins-charge-btn">
          <v-btn
            block
            class="charge-text py-5"
            color="primary"
            depressed
            rounded
            @click="onCharge"
            v-show="showChargeButton"
            :disabled="isButtonDisabled"
          >
            {{ btnChargeText }}
          </v-btn>
          <v-btn
            block
            class="charge-text py-5"
            color="primary"
            depressed
            rounded
            :loading="loadingAvancarButton"
            @click="fakeClick"
            v-if="showAvancarButton && isMobile"
          >
            Avançar
          </v-btn>
        </div>
      </div>
    </div>
  </v-flex>
</template>

<script>
import OrdersService from "../../services/orders.service";
import OrderBump from "./pagarme/OrderBump.vue";
import Util from "@/util";
import { mask } from "vue-the-mask";

export default {
  components: { OrderBump },
  directives: { mask },
  props: {
    order: {
      required: true,
    },
    courseRecommendation: {
      required: false,
      default: [],
    },
    couponEnabled: {
      required: true,
    },
    selectedInstallment: {
      require: false,
      default: null,
    },
    installments: {
      required: false,
      default: [],
    },
    loadingAvancarButton: {
      required: false,
      type: Boolean,
    },
    showAvancarButton: {
      required: false,
      type: Boolean,
    },
    showChargeButton: {
      required: false,
      default: false,
    },
    disableChargeButton: {
      required: false,
      default: true,
    },
    ctaPayment: {
      required: false,
    },
  },
  watch: {
    selectedInstallment: function (newValue, oldValue) {
      this.updateOrderAmount();
    },
    installments: function (newValue, oldValue) {
      this.updateOrderAmount();
    },
    order: function (newOrder, oldOrder) {
      // watch it
      if (oldOrder.items.data.length === 0 && this.$route.query.coupon) {
        this.showCuponArea = true;
        this.code = this.$route.query.coupon;
        this.applyCoupon();
      }
      if (newOrder) {
        this.updateOrderAmount();
      }
    },
  },
  data() {
    return {
      showCuponArea: false,
      couponApplyed: false,
      item: null,
      code: this.order.coupon,
      loading: false,
      orderAmount: null,
      textInstallment: null,
      chargeTriggered: false,
      isMobile: window.innerWidth <= 500
    };
  },
  mounted() {
    this.updateOrderAmount();
  },
  methods: {
    clearCoupon() {
      this.couponEnabled = true;
      this.couponApplyed = false;
      this.code = "";
    },
    updateOrderAmount() {
      this.orderAmount = this.getTotal();
    },
    getTotal() {
      if (this.installments.length <= 0) {
        return "R$ " + Util.formatBR(this.order.net_amount);
      }

      if (this.selectedInstallment && this.order.net_amount !== 0) {
        this.textInstallment = this.selectedInstallment.quantity + "x de ";
        return (
          "R$ " + Util.formatBR(this.selectedInstallment.installmentAmount)
        );
      }

      const installment = this.installments.reduce((prev, current) =>
        prev.quantity > current.quantity ? prev : current,
      );
      if (installment) {
        this.textInstallment = installment.quantity + "x de ";
        return "R$ " + Util.formatBR(installment.installmentAmount);
      }
    },

    applyCoupon() {
      this.loading = true;
      OrdersService.applyCoupon(this.order.id, this.code)
        .then((resp) => {
          this.$emit("couponApplied", resp.data);
          this.updateOrderAmount();
          this.loading = false;
          this.couponApplyed = true;
        })
        .catch((err) => {
          window.getApp.sendSnackMessage(err.message, "error");
          this.loading = false;
        });
    },

    onUpdateCart(order) {
      this.loading = true;
      this.$emit("updateOrder", order);
      this.updateOrderAmount();
      this.loading = false;
    },
    fakeClick() {
      this.$emit("fakeClick");
    },
    onCharge() {
      this.loading = true;
      this.$emit("charged");
      this.loading = false;
    },
  },
  computed: {
    isButtonDisabled() {
      const isDisabled = this.disableChargeButton || !this.selectedInstallment;
      return isDisabled;
    },
    discount() {
      return Util.formatBR(this.order.discount_amount);
    },
    itemPrice() {
      return Util.formatBR(this.order.gross_amount);
    },
    btnChargeText() {
      return this.orderAmount === "R$ 0,00"
        ? "resgatar meu presente"
        : `Finalizar ${this.ctaPayment}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card__actions,
a {
  text-decoration: none;
}
.word-no-break {
  word-break: keep-all;
}
.preco-parcelado {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: baseline;
  p {
    margin-bottom: 0;
  }
  div {
    display: flex;
    flex-wrap: nowrap;
    align-items: baseline;
    gap: 5px;
  }
  .installment {
    font-size: 0.8rem;
  }
  .amount {
    font-weight: normal;
  }
}
.coupon-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
  gap: 15px;
}
.valores-com-cupom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: grey;
}
.total-charge {
  @media (max-width: 500px) {
    padding: 0 26px;
  }
}
.margins-charge-btn {
  margin: 16px -7px;
}
.charge-text {
  font-size: 15px !important;
  @media (max-width: 400px) {
    font-size: 13px !important;
  }
}
.mobile-fixed-filler {
  @media (max-width: 850px) {
    min-height: 820px;
  }
  @media (max-width: 500px) {
    min-height: 140px;
  }
}
.mobile-fixed-bottom {
  padding: 10px;
  border-radius: 15px 15px 0 0;
  @media (max-width: 850px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
  }
  @media (max-width: 450px) {
    padding: 0;
    border-radius: 0;
  }
}
</style>
